import React from "react";
import Svg, { Path } from "react-native-svg";

const Cross = (props) => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M13.6491 12L20.6579 4.9909C21.1141 4.53499 21.1141 3.79784 20.6579 3.34193C20.202 2.88602 19.4649 2.88602 19.009 3.34193L11.9999 10.351L4.99106 3.34193C4.53493 2.88602 3.798 2.88602 3.34209 3.34193C2.88597 3.79784 2.88597 4.53499 3.34209 4.9909L10.3509 12L3.34209 19.009C2.88597 19.4649 2.88597 20.2021 3.34209 20.658C3.5693 20.8854 3.86804 20.9996 4.16658 20.9996C4.46511 20.9996 4.76364 20.8854 4.99106 20.658L11.9999 13.6489L19.009 20.658C19.2364 20.8854 19.5349 20.9996 19.8334 20.9996C20.132 20.9996 20.4305 20.8854 20.6579 20.658C21.1141 20.2021 21.1141 19.4649 20.6579 19.009L13.6491 12Z"
        fill={props.fill ? props.fill : "black"}
        fillOpacity={props.fillOpacity ? props.fillOpacity : "0.7"}
      />
    </Svg>
  );
};

export default Cross;
